<template>
  <el-dialog
    title="拒绝原因"
    class="dialog"
    center
    :visible.sync="reApplyVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="true"
    width="600px"
  >
    <div class="dialog-content">
      <el-form label-suffix="：" label-width="120px">
        <el-form-item label="拒绝原因">
          <span>{{ rejectReason }}</span>
        </el-form-item>
      </el-form>
    </div>
    <template slot="footer">
      <el-button size="small" @click="reApplyCancel">关闭</el-button>
      <!--      <el-button-->
      <!--        size="small"-->
      <!--        type="primary"-->
      <!--        @click="reApplyConfirm"-->
      <!--      >确定</el-button>-->
    </template>
  </el-dialog>
</template>

<script>
export default {
  name: 'ReApplyDialog',

  props: {
    visible: {
      type: Boolean,
      default: false
    },

    rejectReason: {
      type: String,
      default: '-'
    }
  },

  computed: {
    reApplyVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    }
  },

  methods: {
    reApplyCancel() {
      this.reApplyVisible = false
      this.$emit('cancel')
    },

    reApplyConfirm() {
      this.reApplyVisible = false
      this.$emit('confirm')
    }
  }
}
</script>

<style lang="scss" scoped>
.dialog-content {
  width: 100%;
  box-sizing: border-box;
  padding: 0 20px 10px 20px;
}
</style>
